/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Footer_TagInputs */

const en_ledger_footer_tag = /** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Continuity Ledger • SHA-256 Verified`)
};

const es_ledger_footer_tag = /** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de Continuidad del Negocio • Verificado SHA-256`)
};

const fr_ledger_footer_tag = /** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registre de continuité des activités • Vérifié SHA-256`)
};

const de_ledger_footer_tag = /** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptbuch zur Geschäftskontinuität • SHA-256 verifiziert`)
};

const id_ledger_footer_tag = /** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buku Besar Kontinuitas Bisnis • Diverifikasi SHA-256`)
};

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const ja_ledger_footer_tag = en_ledger_footer_tag;

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const zh_ledger_footer_tag = en_ledger_footer_tag;

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const ar_ledger_footer_tag = en_ledger_footer_tag;

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const it_ledger_footer_tag = en_ledger_footer_tag;

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const ru_ledger_footer_tag = en_ledger_footer_tag;

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const pt_ledger_footer_tag = en_ledger_footer_tag;

/** @type {(inputs: Ledger_Footer_TagInputs) => LocalizedString} */
const ko_ledger_footer_tag = en_ledger_footer_tag;

/**
* | output |
* | --- |
* | "Business Continuity Ledger • SHA-256 Verified" |
*
* @param {Ledger_Footer_TagInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ledger_footer_tag = /** @type {((inputs?: Ledger_Footer_TagInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Footer_TagInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ledger_footer_tag(inputs)
	if (locale === "es") return es_ledger_footer_tag(inputs)
	if (locale === "fr") return fr_ledger_footer_tag(inputs)
	if (locale === "de") return de_ledger_footer_tag(inputs)
	if (locale === "ja") return ja_ledger_footer_tag(inputs)
	if (locale === "zh") return zh_ledger_footer_tag(inputs)
	if (locale === "ar") return ar_ledger_footer_tag(inputs)
	if (locale === "id") return id_ledger_footer_tag(inputs)
	if (locale === "it") return it_ledger_footer_tag(inputs)
	if (locale === "ru") return ru_ledger_footer_tag(inputs)
	if (locale === "pt") return pt_ledger_footer_tag(inputs)
	return ko_ledger_footer_tag(inputs)
});